module.exports = __webpack_public_path__ + "static/media/Secondary_Logo.64bf8e49.png";